import { defineView } from "@/ReactSetup/view-definitions";

const definition = defineView({
    name: "SearchBox",
    component: () => (__SERVER__ ? require("./search-box-view") : import("./search-box-view"))
});

export default definition;
